<template>
  <div class="about">
    <HeaderComponent/>
    <div class="wid100">
      <img src="https://cyvideo.i-oranges.com/home/8.jpg" class="wid100" style="vertical-align: middle" alt="">
    </div>
    <div class="wid100">
      <img src="https://cyvideo.i-oranges.com/home/9.jpg" class="wid100" style="vertical-align: middle" alt="">
    </div>
    <div class="wid100">
      <img src="https://cyvideo.i-oranges.com/home/16.jpg" class="wid100" style="vertical-align: middle" alt="">
    </div>
    <div class="wid100 about_service">
      <img src="https://cyvideo.i-oranges.com/home/10.jpg" class="wid100" style="vertical-align: middle" alt="">
      <div class="box">
        <div class="list">
          <div class="icon icon1">
            <img src="https://cyvideo.i-oranges.com/home/ani/1.png" class="wid100" alt="">
            <div class="aniBox">
              <img src="https://cyvideo.i-oranges.com/home/ani/1-1.png" class="img1" alt="">
              <img src="https://cyvideo.i-oranges.com/home/ani/1-2.png" class="img2" alt="">
            </div>
          </div>
          <div class="icon icon1">
            <img src="https://cyvideo.i-oranges.com/home/ani/2.png" class="wid100" alt="">
          </div>
          <div class="icon icon2">
            <img src="https://cyvideo.i-oranges.com/home/ani/3.png" class="wid100" alt="">
            <div class="aniBox">
              <img src="https://cyvideo.i-oranges.com/home/ani/3-1.png" class="img1" alt="">
            </div>
          </div>
          <div class="icon icon3">
            <img src="https://cyvideo.i-oranges.com/home/ani/4.png" class="wid100" alt="">
            <div class="aniBox">
              <img src="https://cyvideo.i-oranges.com/home/ani/4-1.png" class="img1" alt="">
            </div>
          </div>
          <div class="icon icon4">
            <img src="https://cyvideo.i-oranges.com/home/ani/5.png" class="wid100" alt="">
            <div class="aniBox">
              <img src="https://cyvideo.i-oranges.com/home/ani/5-1.png" class="img1" alt="">
            </div>
          </div>
          <div class="icon icon5">
            <img src="https://cyvideo.i-oranges.com/home/ani/6.png" class="wid100" alt="">
            <div class="aniBox">
              <div class="addBox">
                <img src="https://cyvideo.i-oranges.com/home/ani/6-1.png" class="img1" alt="">
                <img src="https://cyvideo.i-oranges.com/home/ani/6-2.png" class="img2" alt="">
                <img src="https://cyvideo.i-oranges.com/home/ani/6-3.png" class="img3" alt="">
                <img src="https://cyvideo.i-oranges.com/home/ani/6-4.png" class="img4" alt="">
              </div>

            </div>
          </div>
          <div class="icon icon6">
            <img src="https://cyvideo.i-oranges.com/home/ani/7.png" class="wid100" alt="">
<!--            <div class="aniBox">-->
<!--              <img src="https://cyvideo.i-oranges.com/home/ani/5-1.png" class="img1" alt="">-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="day">
      <div class="info">
<!--          <div class="title">-->
<!--            <img src="https://cyvideo.i-oranges.com/home/10.png" class="wid100" style="vertical-align: middle" alt="">-->
<!--          </div>-->
        <div class="slide LeftTop">
            <div class="left">
              <img src="https://cyvideo.i-oranges.com/home/11.png" class="wid100" style="vertical-align: middle" alt="">
            </div>
            <div class="right">
              <div class="swiper-container about_Swiper1" id="mySwiper1" >
                <div class="swiper-wrapper">
                  <div class="swiper-slide"  v-for="(banner, index) in banners" :key="index">
                    <div class="wid100" style="position: relative">
                      <img :src="banner.imgUrl" preview="0" :preview-text="banner.title" alt=""/>
                      <div class="mask Center">
                        <button>VIEW <img src="https://cyvideo.i-oranges.com/home/view1.png"> </button>
                      </div>
                    </div>

                    <span>{{banner.title}}</span>
                  </div>
                </div>
                <!-- 分页器 -->
                <div class="swiper-scrollbar"></div>
                <div class="swiper-pagination"></div>
                <!-- 导航按钮 -->
<!--                <div class="swiper-button-prev add_button-prev add_button-prev-bg"></div>-->
<!--                <div class="swiper-button-next add_button-next add_button-next-bg"></div>-->

              </div>

            </div>
          </div>
      </div>

    </div>

    <div class="os">
      <div class="swiper-container about_Swiper2" id="mySwiper2">
        <div class="swiper-wrapper">
          <div class="swiper-slide"   v-for="(banner, index) in banners1" :key="index">
            <img v-if="banner.type =='img'" :src="banner.url" preview="0" :preview-text="banner.imgUrl"  alt=""/>
            <video v-else controls="controls" muted  class="wid100" :src="banner.url" ></video>
          </div>
        </div>
        <!-- 分页器 -->
<!--        <div class="swiper-scrollbar"></div>-->
        <!-- 分页器 -->
        <div class="swiper-scrollbar"></div>
        <div class="swiper-pagination"></div>
        <!-- 导航按钮 -->
        <!--                <div class="swiper-button-prev"></div>-->
        <!--                <div class="swiper-button-next"></div>-->
      </div>
    </div>
<!--    <ServiceComponent/>-->
    <FooterComponent/>
    <BackToTop :visibility-height="500" :bottom="50" :right="50"/>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent'
import FooterComponent from '../components/FooterComponent'
import ProjectComponent from '../components/ProjectComponent'
import ServiceComponent from '../components/ServiceComponent'
import Swiper from "swiper";


export default {
  name: "about",
  components: {
    HeaderComponent,
    FooterComponent,
    ProjectComponent,
    ServiceComponent,

  },
  data() {
    return {
      banners: [
        {  imgUrl: 'https://cyvideo.i-oranges.com/home/19.jpg',title:""},
        { imgUrl: 'https://cyvideo.i-oranges.com/home/20.jpg',title:"" },
        { imgUrl: 'https://cyvideo.i-oranges.com/home/21.jpg',title:"" },
        { imgUrl: 'https://cyvideo.i-oranges.com/home/22.jpg' ,title:""},

      ],
      banners1:[
        { type:"img", url: 'https://cyvideo.i-oranges.com/home/23.png'},
        { type:"img", url: 'https://cyvideo.i-oranges.com/home/24.jpg'},
        { type:"img", url: 'https://cyvideo.i-oranges.com/home/14-6.jpg'},
        // { type:"img", url: 'https://cyvideo.i-oranges.com/home/13.jpg'},
        { type:"img", url: 'https://cyvideo.i-oranges.com/home/14.jpg'},
        { type:"video", url: "https://cyvideo.i-oranges.com/home/about1.mp4"},
        { type:"img", url: 'https://cyvideo.i-oranges.com/home/14-1.jpg'},
        { type:"img", url: 'https://cyvideo.i-oranges.com/home/14-2.jpg'},
        { type:"img", url: 'https://cyvideo.i-oranges.com/home/14-3.jpg'},
        { type:"img", url: 'https://cyvideo.i-oranges.com/home/14-4.jpg'},
        { type:"img", url: 'https://cyvideo.i-oranges.com/home/14-5.jpg'},
      ],
      // 轮播图数据
      mySwiper: null, // 用于保存Swiper实例
    };
  },
  methods:{
    initSwiper() {
      let thatVideo='';
      this.mySwiper = new Swiper('#mySwiper1', {
        loop: false, // 循环模式
        // slidesPerView: 3.6,
        spaceBetween: 1,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          dragSize: 100,
          draggable: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },

        navigation: {
          nextEl: '.swiper-button-next', // 下一页按钮
          prevEl: '.swiper-button-prev', // 上一页按钮
        },
      });
      this.mySwiper = new Swiper('#mySwiper2', {
        loop: false, // 循环模式
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          dragSize: "auto",
          draggable: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },
        on:{
          slideChangeTransitionEnd: function(){

            let element = this.slides[this.activeIndex].children[0];
            if (element.tagName === 'VIDEO') {
              element.play()
              thatVideo = element;
            }else{
              thatVideo.pause()
            }
          }
        },

        navigation: {
          nextEl: '.swiper-button-next', // 下一页按钮
          prevEl: '.swiper-button-prev', // 上一页按钮
        },
      });
    },
    openPreview() {

    }
  },
  mounted() {
    this.initSwiper(); // 初始化Swiper
    this.$previewRefresh()
  },
  watch: {

  },
}
</script>

<style scoped>
.about {
  width: 100%;
}
.about .os{width: 76%; margin: 80px auto 100px auto;}
.day{width: 100%; position: relative; background: #fff; display: inline-block; padding-bottom: 100px;}
.day .info{width: 76%; height: 100%; margin: 0 auto;}
.day .info .title{width: 100%; margin-top: 106px; }
.day .info .slide{width: 100%; margin-top: 140px; }
.day .info .left{width: 30%; }
.day .info .left img{width: 100%; }
.day .info .right{width: 70%; margin-left:6%; }
.swiper-slide{width: 100%;cursor: pointer;}
.mask{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255,255, 0.13);
  backdrop-filter: blur(2px);
  opacity: 0;
  pointer-events: none;
  transition: all 0.5s;
}
.swiper-slide:hover .mask{opacity: 1; }
.mask button{  transition: all 0.5s; width:150px; letter-spacing: 2px; background: #ff6600;color: #fff;  font-size: 14px; padding: 10px 0; border: 0;    box-shadow:-1px 6px 20px 0px #000000;;}
.mask button img{width: 20px; margin-left: -5px;}
.swiper-slide img{width: 100%;}
#mySwiper1 span{color: #808080;  font-size: 16px; margin-top:23px; margin-bottom: 40px; display: inline-block; width: 80%}
.swiper-scrollbar{background: #000; height: 3px; background-size: 100% 1px;}
.about_service{position: relative;}
.about_service .box{position: absolute; width: 76%; left:12%; bottom: 0; height: 23%;}
.about_service .box .list{width: 100%;display: flex;justify-content: space-around;align-items: center;}
.about_service .box .icon{position: relative;}
.about_service .box .icon{width: 5%;}
.about_service .aniBox{position: absolute;width: 100%; height: 100%; top:0;}
.about_service .aniBox img{position: absolute;}
.about_service .icon1 .img1{ width: 28%;position: absolute;  top:0; left: 23%;
  animation: ro1 1s linear infinite; transform-origin: 100% 100%;}

.about_service .icon1 .img2{ width: 20%;position: absolute;  top:0; left: 55%;
  animation: ro2 1s linear infinite; transform-origin: 0 100%;
}.about_service .icon1 .img2{ width: 20%;position: absolute;  top:0; left: 55%;
  animation: ro2 1s linear infinite; transform-origin: 0 100%;
}
@-webkit-keyframes ro1 { 0%,100%{ transform: rotate(0);} 50%{transform: rotate(-10deg);} }
@-webkit-keyframes ro2 { 0%,100%{ transform: rotate(0);} 50%{transform: rotate(10deg);} }

@-webkit-keyframes ro3 { 0%,100%{ transform: translateY(0);} 50%{transform: translateY(8px) rotate(1deg);} }
@-webkit-keyframes ro4 {
  0%,100%{ transform: scale(1) translate(0,0);}
  50%{transform: scale(1.2) translate(3px,-3px) ;}
}
@-webkit-keyframes ro5 {
  0%,100%{ transform: translate(0,0) ;}
  25%{ transform: translate(-4px,0) ;}
  50%{transform:translate(0,0) ;}
  75%{transform:translate(4px,0) ;}
}
@-webkit-keyframes ro6 {
  0%,100%{ transform: translate(0,0) ;}
  5%{ transform: translate(0,12px) ;}
  10%{ transform: translate(0,0) ;}
  15%{ transform: translate(0,12px) ;}
  20%{ transform: translate(0,0) ;}
}
@-webkit-keyframes ro7 {
  0%,100%{ transform: translate(0,0) ;}
  5%{ transform: translate(0,-4px) ;}
  10%{ transform: translate(0,0) ;}
  15%{ transform: translate(0,-4px) ;}
  20%{ transform: translate(0,0) ;}


}
.aniBox .addBox{  width: 100%;
  height: 60%;
  margin-top: 40%;
  overflow: hidden;
  position: relative;
}
.about_service .icon2 .img1{
  width: 42%;
  position: absolute;
  top: 19%;
  left: 58%;
  animation: ro3 3s linear infinite; transform-origin: 100% 100%;}
.about_service .icon3 .img1{
  width: 22%;
  position: absolute;
  top: 0;
  left: 77%;
  animation: ro4 2s linear infinite; transform-origin: 50% 100%;
}
.about_service .icon4 .img1{
  width: 45%;
  position: absolute;
  top: 38%;
  left: 20%;
  animation: ro5 3s linear infinite; transform-origin: 50% 100%;
}


.about_service .icon5 .img1{
  width: 29%;
  position: absolute;
  top:-30%;
  left: 4.2%;
  animation: ro6 3s ease-in-out infinite; transform-origin: 50% 100%;
}
.about_service .icon5 .img2{
  width: 29%;
  position: absolute;
  top: 31%;
  left:5.5%;
  animation: ro7 3s ease-in-out infinite; transform-origin: 50% 100%;
}
.about_service .icon5 .img3{
  width: 29%;
  position: absolute;
  top:-30%;
  left: 45%;
  animation: ro6 3s ease-in-out infinite; transform-origin: 50% 100%;
}
.about_service .icon5 .img4{
  width: 29%;
  position: absolute;
  top: 31%;
  left:45.5%;
  animation: ro7 3s ease-in-out infinite; transform-origin: 50% 100%;
}


.about_service .icon6 .img1{
  width: 45%;
  position: absolute;
  top: 38%;
  left: 20%;

}
</style>


<style>
.about .swiper-pagination{z-index: 2 !important;}
.about_Swiper1 .swiper-slide{ margin-bottom: 5px;}
.about_Swiper2 .swiper-slide{ margin-bottom: 60px;}
.about_Swiper1 .swiper-scrollbar{background: #000; height: 2px !important; background-size: 100% 1px;bottom:50px !important; cursor: pointer}
.about_Swiper2 .swiper-scrollbar{background: #ff6600; height: 2px !important; background-size: 100% 1px;bottom:40px !important;cursor: pointer}
.about_Swiper1 .swiper-scrollbar-drag{background: #ff6600 !important; height: 6px; margin-top: -2px;}
.about_Swiper2 .swiper-scrollbar-drag{background: #fff !important; height: 6px; margin-top: -2px;}
.about_Swiper1 .swiper-pagination-bullet,.about_Swiper2 .swiper-pagination-bullet{width: auto!important;background: none !important; height: auto !important; padding-bottom: 2px; color: rgba(255,102,0,0.2); font-size: 20px; margin: 0 3px !important; }
.about_Swiper1 .swiper-pagination-bullet-active,.about_Swiper2 .swiper-pagination-bullet-active{border-bottom: 2px solid #ff6600; border-radius: 0;color: rgba(255,102,0,1);}
.about .swiper-pagination-bullet-active {
  background: none !important;
}
.about .swiper-pagination-bullets{ bottom: -0px!important;}

.about .pswp__caption{height: 16%;}
.about .pswp__caption__center {
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/view/about.vue